import { t } from 'i18next'
import { Dropdown, DropdownChangeParams } from 'primereact/dropdown'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { ClothSizeCt } from '../../../../../model/enums/enums'

export interface SizeOption {
  label: string
  value: ClothSizeCt | null
}

export const SizeDropdown = () => {
  const { control } = useFormContext()

  const sizes: SizeOption[] = [
    { label: t<string>('core.no_specification'), value: null },
    { label: 'XXS', value: ClothSizeCt.XXS },
    { label: 'XS', value: ClothSizeCt.XS },
    { label: 'S', value: ClothSizeCt.S },
    { label: 'M', value: ClothSizeCt.M },
    { label: 'L', value: ClothSizeCt.L },
    { label: 'XL', value: ClothSizeCt.XL },
    { label: 'XXL', value: ClothSizeCt.XXL },
    { label: 'XXXL', value: ClothSizeCt.XXXL },
  ]

  return (
    <Controller
      name="cloth_size"
      control={control}
      render={({ field }) => (
        <Dropdown
          appendTo={document.body}
          id={'SizeDropdown'}
          value={field.value || ''}
          options={sizes}
          onChange={(changeParams: DropdownChangeParams) => {
            field.onChange(changeParams.value)
          }}
          placeholder={t<string>('core.select')}
        />
      )}
    />
  )
}